import { render } from "./CreateTariffView.vue?vue&type=template&id=5c265b30"
import script from "./CreateTariffView.vue?vue&type=script&lang=js"
export * from "./CreateTariffView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__